import { Plus } from 'lucide-react'
import { useState } from 'react'
import { PageFrame } from 'shared/components/page-frame'
import { SectionTitle } from 'shared/components/section'
import { ToneNote } from 'shared/components/tone-banner'
import { Button } from 'shared/components/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from 'shared/components/ui/dialog'
import { useTranslate } from 'shared/lib/i18n'
import { AwaitingReturns } from './AwaitingReturns'
import { RegisterReturn } from './RegisterReturn'

/**
 * «Возвраты покупок» (ADR-0037, spec §18; tickets 42, 44): the buyers' returns support
 * registered for a partner without an API and no Point has accepted yet, as one
 * table — and «Зарегистрировать возврат» in the header, the form in a dialog. A
 * partner with an API registers and cancels its returns itself.
 */
export function SupportReturns() {
	const { t } = useTranslate()
	const [registering, setRegistering] = useState(false)
	const [registered, setRegistered] = useState<{ count: number; text: string } | null>(null)
	const [count, setCount] = useState<number | undefined>()

	return (
		<PageFrame
			title='nav.supportReturns'
			actions={
				<Button
					onClick={() => {
						setRegistered((r) => (r ? { ...r, text: '' } : r))
						setRegistering(true)
					}}
					data-testid='register-return-open'
				>
					<Plus />
					{t('registerReturn.open')}
				</Button>
			}
		>
			{registered?.text && (
				<ToneNote tone='ready' title={registered.text} testId='register-return-message' />
			)}
			<section className='flex flex-col gap-2'>
				<SectionTitle title={t('returnCancel.title')} count={count} hint={t('registerReturn.hint')} />
				<AwaitingReturns refreshKey={registered?.count ?? 0} onCount={setCount} />
			</section>
			<Dialog open={registering} onOpenChange={setRegistering}>
				<DialogContent className='sm:max-w-2xl' data-testid='register-return-dialog'>
					<DialogHeader>
						<DialogTitle>{t('registerReturn.title')}</DialogTitle>
						<DialogDescription>{t('registerReturn.hint')}</DialogDescription>
					</DialogHeader>
					<RegisterReturn
						onCancel={() => setRegistering(false)}
						onRegistered={(text) => {
							setRegistering(false)
							setRegistered((r) => ({ count: (r?.count ?? 0) + 1, text }))
						}}
					/>
				</DialogContent>
			</Dialog>
		</PageFrame>
	)
}
